import { useEffect } from 'react';
import { useAvailablePrizes } from 'features';
import { useWidget } from '@telescope/cassini-hooks';
import { Open } from 'types';
import { Text } from 'components';

export const AvailablePrizeMessage = () => {
  const { data: widgetData } = useWidget({ select: (data: Open) => data });
  const { sid } = widgetData!;

  const { data: authData } = useWidget({ select: (data: Open) =>  data.widget.global_views.auth });
  const { content: { unavailablePrizesMessage }, settings: { isUnavailablePrizesMessageEnabled } } = authData!;

  const { refetchAvailablePrizes, hasAvailablePrize } = useAvailablePrizes({ isEnabled: !!isUnavailablePrizesMessageEnabled, sid });

  useEffect(() => {
    refetchAvailablePrizes();
  }, [refetchAvailablePrizes])

  if (!isUnavailablePrizesMessageEnabled || hasAvailablePrize === true) return null;

  return (
    <Text align="center" mt={12} mb={3}> {unavailablePrizesMessage} </Text>
  )
}